var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndependant03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9759 6.75007H11.5714C11.236 6.74744 10.9039 6.81724 10.5979 6.95471C10.292 7.09217 10.0192 7.29405 9.79842 7.54657C9.57482 7.79983 9.40747 8.09763 9.30741 8.42032C9.20735 8.743 9.17685 9.08323 9.21792 9.41857L12.9124 40.9366C13.1149 42.6848 13.9474 44.2936 15.2524 45.4591C16.5504 46.6221 18.2347 47.2605 19.9774 47.2501H35.6599C37.4027 47.2605 39.0869 46.6221 40.3849 45.4591C41.6899 44.2936 42.5224 42.6848 42.7249 40.9366L46.3047 9.41857C46.3445 9.08536 46.3143 8.74749 46.2158 8.42666C46.1174 8.10583 45.953 7.80912 45.7332 7.55557C45.5138 7.30477 45.2438 7.10332 44.9409 6.96447C44.638 6.82563 44.3091 6.75256 43.9759 6.75007Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.606 21.0444C16.9892 18.6616 23.7685 16.5421 29.0695 20.7339C34.3682 24.9279 39.4555 24.2124 44.7295 23.1189M18.355 32.7894L18.895 36.6256C19.0457 37.5661 19.5115 38.4256 20.2157 39.0579C20.9166 39.69 21.8153 40.059 22.7582 40.1019L25.114 40.2211",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependant03);
export default __webpack_public_path__ + "static/media/independant03.7a33ac86b144e79a97f1061294f04995.svg";
export { ForwardRef as ReactComponent };